
import '~/js/views/general/about/includes/stickyNav';
import '~/js/views/general/about/includes/scroll-below';
import '~/js/views/general/about/includes/slider-timeline';

const about = location.search.split('about=')[1];
const scrollTo = location.search.split('scrollTo=')[1];

window.onload = () => {
    if (about) {
        const scrollTarget = document.getElementById('ourBrands');
        const destination = scrollTarget.offsetTop;

        $('html:not(:animated),body:not(:animated)').animate({
            scrollTop: destination
        }, 1100);
    } else if (scrollTo) {
        $('html:not(:animated),body:not(:animated)').animate({
            scrollTop: document.getElementById(scrollTo).offsetTop - 100
        }, 1100);
    }
};


$('body').scrollspy({
    target: '.js-scroll-spy-this',
    offset: 120
});


$(document)
    .on('click', '.js-read-more', function toggleReadMore() {
        const readMore = $(this).siblings('.js-read-more-hide').is(':visible') ? 'Read More' : 'Read Less';
        const dataClass = $(this).data('bio');

        $(this).text(readMore);
        $('.js-read-more-hide.' + dataClass).slideToggle();
    })
    .on('click', '.js-go-here', function goHere(e) {
        e.preventDefault();

        const hash = this.hash;
        const $main = $('html, body');

        if($(window).width() >= '768') {
            $main.animate({
                scrollTop: $(hash).offset().top - 40
            }, 1000);
        } else {
            $main.animate({
                scrollTop: $(hash).offset().top - 80
            }, 1000);
        }
    });
